import { useQuery } from "@tanstack/react-query";
import type { AccountSwitcherUiAPIInterfaceInternalNew } from "@dealer-center/ddc-api-lambda-helper-add";
import type {
  AccountSwitcherUiAPIInterfaceInternal,
  AccountSwitcherUiFetchInterface
} from "@dealer-center/ddc-pages-account-switcher-ui-interface";

const queryKeyBase = "ddc-pages-account-switcher-ui";

export function useAccountSwitcherUiAPIInterface({
  searchValue
}: AccountSwitcherUiFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { searchValue }],
    queryFn: () => getFunction(searchValue?.trim() || ""),
    enabled: !!searchValue && searchValue.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  searchValue: string
): Promise<AccountSwitcherUiAPIInterfaceInternal[]> => {
  const res = await fetch("/landing/nxlambda/accountSwitcherUi/" + searchValue);
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};

export function useAccountSwitcherUiAPIInterfaceNew({
  searchValue
}: AccountSwitcherUiFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase + "-new", { searchValue }],
    queryFn: () => getFunctionNew(searchValue?.trim() || ""),
    enabled: !!searchValue && searchValue.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunctionNew = async (
  searchValue: string
): Promise<AccountSwitcherUiAPIInterfaceInternalNew> => {
  const res = await fetch("/landing/nxlambda/account/switcher/" + searchValue);
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
